import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../../services/shared.service';
import { UserPreferencesService } from '../../../../services/user-preferences';

@Component({
  selector: 'add-person-header',
  templateUrl: './add-person-header.component.html',
  styleUrls: ['./add-person-header.component.scss'],
  standalone: false
})
export class AddPersonHeaderComponent implements OnInit {
  public params: any;
  public sortByLast: boolean;

  constructor(
    private sharedService: SharedService,
    private userPrefSvc: UserPreferencesService
  ) {}

  ngOnInit(): void {}

  agInit(params) {
    this.params = params;
    this.sortByLast = params.sortByLast;
  }

  public addPerson() {
    // pass the list of personIds that are currently in the payroll
    let personIds = [];
    this.params.api.forEachNode(node => {
      if (!personIds.includes(node.data.PersonId)) {
        personIds.push(node.data.PersonId);
      }
    });

    this.sharedService.openAddPersonToPayrollModal.next(personIds);
  }

  public setPrefs(sortByLast) {
    this.sortByLast = JSON.parse(sortByLast); // cast 'true' | 'false' | 'null' out of strings
    this.userPrefSvc
      .setPayrollEmployeeSortOrder(this.params.clientCode, this.sortByLast)
      .subscribe(prefs => {
        // save preferences back to paygrid component's in memory object
        if (typeof this.params?.callback === 'function') {
          this.params.callback(prefs);
        }
      });
  }
}
